import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './error-pages.scss';

const ServiceUnavailablePage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__brand">RealityCoach</div>

        <div className="error-page__icon">🔌</div>

        <h1 className="error-page__title">{t('errorPages.serviceUnavailable')}</h1>

        <p className="error-page__description">
          {t('errorPages.serviceUnavailableDescription')}
        </p>

        <div className="error-page__actions">
          <button className="error-page__btn-primary" onClick={() => window.location.reload()}>
            {t('common.retry')}
          </button>
          <button className="error-page__btn-secondary" onClick={() => navigate('/')}>
            {t('errorPages.goToDashboard')}
          </button>
        </div>

        <div className="error-page__info-box error-page__info-box--warning">
          <p>
            {t('errorPages.checkConnection')}
          </p>
        </div>

        <p className="error-page__footer">{t('errorPages.serviceUnavailableCode')}</p>
      </div>
    </div>
  );
};

export default ServiceUnavailablePage;
